import { cn } from "../lib/utils";

export const EmptyState = ({ icon, title, description, action, className, "data-testid": testId }) => (
    <div
        data-testid={testId}
        className={cn(
            "flex flex-col items-center justify-center text-center py-16 px-6 border border-dashed border-slate-200 rounded-lg bg-white",
            className
        )}
    >
        {icon && <div className="text-slate-400 mb-3">{icon}</div>}
        <h3 className="font-display text-lg font-semibold text-slate-900">{title}</h3>
        {description && (
            <p className="text-sm text-slate-500 mt-1 max-w-md">{description}</p>
        )}
        {action && <div className="mt-5">{action}</div>}
    </div>
);

export default EmptyState;
